import useSubJob from '@/use/useSubJob';
import {
  _primaryControls,
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  description,
  material_code,
  amount,
  unit,
  status,
  heat_treatment,
  surface_treatment,
  target_date,
  _remarksControls,
  leadTime,
  _startDateControls,
  _finishDateControls,
  created_at,
  updated_at,
} from '@/table/Job/SubJob/base';

export const qc_progress_amount = {
  name: 'จำนวนที่รับเข้า QC',
  width: '5rem',
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
};
export const qc_surface_amount = {
  name: 'จำนวน ส่งชุบผิว',
  width: '5rem',
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
};
export const qc_heat_amount = {
  name: 'จำนวน ส่งชุบแข็ง',
  width: '5rem',
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
};
export const qc_production_amount = {
  name: 'จำนวนส่ง Production',
  width: '5rem',
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
};
export const qc_claim_amount = {
  name: 'จำนวน ส่งเคลม',
  width: '5rem',
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
};
export const qc_store_amount = {
  name: 'จำนวนส่ง Store',
  width: '5rem',
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
};

const { qcStatusClassMap, translateQCStatus } = useSubJob();

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    description,
    material_code,
    // size: {
    //   name: 'ขนาดชิ้นส่วน',
    //   width: '10rem',
    // },
    amount: {
      ...amount,
      name: 'จำนวน ทั้งหมด',
    },
    qc_progress_amount,
    qc_surface_amount,
    qc_heat_amount,
    qc_production_amount,
    qc_claim_amount,
    qc_store_amount,
    // withdrawn_amount,
    // purchased_amount,
    // qc_pass_amount: {
    //   name: 'จำนวนผ่าน',
    //   width: '4rem',
    // },
    // qc_ng_amount: {
    //   name: 'จำนวน NG',
    //   width: '4rem',
    // },
    // _qc_receive_amount_Controls: {
    //   ...qc_receive_amount,
    //   width: '7rem',
    //   class: {
    //     text: 'text-center',
    //     cell: 'text-center',
    //   },
    // },
    unit,
    qc_status: {
      ...status,
      name: 'สถานะ (ปัจจุบัน)',
      filter: (val: string, row: any) => translateQCStatus(row.item.qc_status),
      class: {
        cell: 'text-center',
        text: (val: string, row: any) => qcStatusClassMap(row.item.qc_status),
      },
    },
    heat_treatment,
    surface_treatment,
    _startDateControls,
    _finishDateControls,
    target_date,
    _remarksControls,
    leadTime,
    created_at,
    updated_at,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    // 'withdrawn_amount',
    // 'purchased_amount',
    'unit',
    'heat_treatment',
    'surface_treatment',
    'target_date',
    'qc_status',
    'created_at',
    'updated_at',
  ],
};
